(function () {
  const requiredText = ['UNLOCK 10% OFF', 'SIGN ME UP', 'NO, THANKS'];
  const selector = 'div, section, aside, form';
  const maxRuns = 80;
  let runs = 0;

  function hasPopupText(element) {
    const text = (element.innerText || element.textContent || '').replace(/\s+/g, ' ').toUpperCase();
    return requiredText.every((copy) => text.includes(copy));
  }

  function findDismissibleRoot(element) {
    let root = element;
    let current = element;

    while (current && current.parentElement && current.parentElement !== document.body) {
      const styles = window.getComputedStyle(current);
      const zIndex = Number.parseInt(styles.zIndex, 10);

      if (styles.position === 'fixed' || styles.position === 'sticky' || zIndex >= 1000) {
        root = current;
      }

      current = current.parentElement;
    }

    return root;
  }

  function unlockPage() {
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.classList.remove('klaviyo-form-open');
  }

  function suppressSignupPopup() {
    runs += 1;

    const match = Array.from(document.querySelectorAll(selector)).find(hasPopupText);
    if (!match) {
      return runs >= maxRuns;
    }

    const root = findDismissibleRoot(match);
    root.setAttribute('aria-hidden', 'true');
    root.style.setProperty('display', 'none', 'important');
    root.style.setProperty('visibility', 'hidden', 'important');
    unlockPage();

    return true;
  }

  const observer = new MutationObserver(() => {
    if (suppressSignupPopup()) {
      observer.disconnect();
    }
  });

  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  }

  const interval = window.setInterval(() => {
    if (suppressSignupPopup()) {
      window.clearInterval(interval);
      observer.disconnect();
    }
  }, 250);
})();
